'use strict'

import { AES } from 'crypto-js'

import axios from '../network'
import config from '../../config'

export {
  login
}

function login ({ user, password, remember }, fn) {
  axios.post('/login', {
    user,
    password: AES.encrypt(password, config.secret).toString(),
    remember
  }).then(response => {
    fn(null, response)
  }).catch(error => {
    fn(error)
  })
}



// WEBPACK FOOTER //
// ./src/libs/api/user.js